module.exports = __webpack_public_path__ + "img/l1.1.ce24205b.png";